import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularMarketOrder: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_market-order"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="market-order icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.16659 3.33301C4.62682 3.33301 4.99992 3.7061 4.99992 4.16634V14.1663C4.99992 14.6266 5.37301 14.9997 5.83325 14.9997H15.8333C16.2935 14.9997 16.6666 15.3728 16.6666 15.833C16.6666 16.2932 16.2935 16.6663 15.8333 16.6663H5.83325C4.45254 16.6663 3.33325 15.5471 3.33325 14.1663V4.16634C3.33325 3.7061 3.70635 3.33301 4.16659 3.33301ZM14.1666 7.49967C13.7063 7.49967 13.3333 7.87277 13.3333 8.33301C13.3333 8.79324 13.7063 9.16634 14.1666 9.16634C14.6268 9.16634 14.9999 8.79324 14.9999 8.33301C14.9999 7.87277 14.6268 7.49967 14.1666 7.49967ZM11.6666 8.33301C11.6666 6.9523 12.7859 5.83301 14.1666 5.83301C15.5473 5.83301 16.6666 6.9523 16.6666 8.33301C16.6666 9.71372 15.5473 10.833 14.1666 10.833C13.894 10.833 13.6316 10.7894 13.386 10.7087L11.4641 12.6306C11.1386 12.956 10.611 12.956 10.2856 12.6306L9.12484 11.4698L7.38076 13.2139C7.05532 13.5394 6.52769 13.5394 6.20225 13.2139C5.87681 12.8885 5.87681 12.3608 6.20225 12.0354L8.53558 9.70207C8.86102 9.37663 9.38866 9.37663 9.71409 9.70207L10.8748 10.8628L12.0592 9.67853C11.8107 9.29009 11.6666 8.82837 11.6666 8.33301Z"
        />
      </svg>
    </span>
  );
};

export { RegularMarketOrder };
